import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
/** TODO: This is a dummy class and does not actually do any of the work The Registry does. */
export class TranslationService {
    /** TODO: This does not do what The Registry does. */
    public getText = (value: string | undefined): Observable<string | undefined> => {
        return of(value);
    };
}
